import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Form, Modal, Button } from "react-bootstrap"
import { getTranslation } from 'utils/renderLanguage'

const AchievementForm = props => {

  const [ achievement, setKpi ] = useState({
    achievement_title: '',
    achievement_description: '',
    achievement_document: '',
    achievement_submission_date: '',
    achievement_submission_note: '',
    achievement_status: 'Pending',
    project_id: props.projectDetail.project_id,
  })

  useEffect( () => {
    if( props.selectedAchievement && props.mode === 'update' ){
      setKpi( props.selectedAchievement )
    }
  }, [] )

  const handleSubmit = () => {
    if( props.mode === 'create' )
      props.createNewAchievement( achievement )
    else 
      props.updateAchievement( achievement )
  }

  const onChangeField = ( val, context ) => {
    let temp = _.cloneDeep( achievement )
    temp[ context ] = val
    setKpi( temp )
  }

  return(
    <Modal show={ true } onHide={() => props.setOpen(false)} size="xl" >
      <Modal.Header closeButton>
        <Modal.Title>{ props.title }</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Achievement' ) }</Form.Label>
          <Form.Control
            type={ 'text' }
            placeholder={ getTranslation( props.language, 'Achievement' ) }
            value={ achievement.achievement_title }
            onChange={ e => onChangeField( e.target.value, 'achievement_title' ) }
          />
        </Form.Group>
        <Form.Group className='mt-3'>
          <Form.Label>{ getTranslation( props.language, 'Description' ) }</Form.Label>
          <Form.Control
            type={ 'text' }
            style={{ minHeight: 200 }}
            placeholder={ getTranslation( props.language, 'Description' ) }
            as="textarea"
            value={ achievement.achievement_description }
            onChange={ e => onChangeField( e.target.value, 'achievement_description' ) }
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={() => props.setOpen( false ) } >
          { getTranslation( props.language, 'Close' ) }
        </Button>
        <Button
          variant="primary"
          disabled={ !achievement.achievement_title || !achievement.achievement_description } 
          onClick={ handleSubmit } >
          { getTranslation( props.language, 'Submit' ) }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AchievementForm;